import { ConnectedRouter } from 'connected-react-router/immutable';
import { History } from 'history';
import React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { createGlobalStyle } from 'styled-components';
import { GlobalStyle } from 'styles/global.style';

import AppRouter from 'router';
import { IGlobalState } from 'types/global';
import { SecureRoute, Security } from '@okta/okta-react';
import { oktaAuth } from 'config/okta.config';
import { Route, Switch } from 'react-router';
import CustomImplicitCallback from './oktaImplicitCallback';

interface IAppProps {
  store: Store<IGlobalState>;
  history: History;
}

const GlobalStyles = createGlobalStyle`${GlobalStyle}`;
const AccessDenied = () => <>Access Denied</>;

export default (props: IAppProps) => {
  const { store, history } = props;
  const CustomRoute = process.env.LOCAL === 'true' ? Route : SecureRoute;
  return (
    <>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Security oktaAuth={oktaAuth}>
            <Switch>
              <Route exact path="/access-denied" component={AccessDenied} />
              <Route path="/callback" component={CustomImplicitCallback} />
              <CustomRoute path="/" component={AppRouter} />
            </Switch>
          </Security>
        </ConnectedRouter>
      </Provider>
      <GlobalStyles />
    </>
  );
};
